import axios from 'axios'

export const httpClient = axios.create({
    // timeout: 1000 * 60,
});





// WEBPACK FOOTER //
// ./src/config/httpclient.js